import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { PNotifyService } from '../../../services/pnotify.service';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';

declare var $;

@Component({
  selector: 'app-push-config',
  templateUrl: './push-config.component.html',
  styleUrls: ['./push-config.component.css']
})
export class PushConfigComponent implements OnInit {

  configs: any[] = [];
  pnotify = undefined;
  weatherLoading = false;

  // Debug config
  debugEnabled = false;
  debugMadarstopToken = '';
  debugMadarproToken = '';

  // Weather config
  weatherEnabled = false;
  weatherHour = '07';
  weatherMinute = '00';
  weatherCityIds: number[] = [];
  cities: any[] = [];
  cityOptions: IMultiSelectOption[] = [];
  hours: string[] = [];

  // Multiselect config
  multiSelectSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    showCheckAll: true,
    showUncheckAll: true,
    buttonClasses: 'btn btn-default btn-block',
    dynamicTitleMaxItems: 3,
    displayAllSelectedText: true
  };
  multiSelectTexts: IMultiSelectTexts = {
    checkAll: 'Tout sélectionner',
    uncheckAll: 'Tout déselectionner',
    checked: 'ville sélectionnée',
    checkedPlural: 'villes sélectionnées',
    searchPlaceholder: 'Rechercher...',
    defaultTitle: 'Toutes les villes',
    allSelected: 'Toutes les villes'
  };

  constructor(
    private http: HttpClient,
    pnotifyService: PNotifyService
  ) {
    console.log('[PushConfig] Constructor started');
    this.pnotify = pnotifyService.getPNotify();
    for (let h = 0; h < 24; h++) {
      this.hours.push(h < 10 ? '0' + h : '' + h);
    }
  }

  ngOnInit() {
    this.loadConfigs();
    this.loadWeatherConfig();
    this.loadDebugConfig();
    this.loadCities();
    $('[data-toggle="tooltip"]').tooltip();
  }

  loadConfigs() {
    this.http.get('/api/push/config').subscribe((configs: any[]) => {
      this.configs = configs;
    });
  }

  loadWeatherConfig() {
    this.http.get('/api/push/weather-config').subscribe((cfg: any) => {
      this.weatherEnabled = cfg.enabled;
      this.weatherHour = String(cfg.hour || 7).padStart(2, '0');
      this.weatherMinute = String(cfg.minute || 0).padStart(2, '0');
      this.weatherCityIds = cfg.cityIds || [];
    });
  }

  loadCities() {
    this.http.get('/api/push/weather-cities').subscribe((cities: any[]) => {
      this.cities = cities;
      this.cityOptions = cities.map(c => ({ id: c.id, name: c.name }));
    });
  }

  loadDebugConfig() {
    this.http.get('/api/push/debug-config').subscribe((cfg: any) => {
      this.debugEnabled = cfg.enabled;
      this.debugMadarstopToken = cfg.madarstopToken || '';
      this.debugMadarproToken = cfg.madarproToken || '';
    });
  }

  onDebugEnabledChange() {
    this.saveDebugConfig();
  }

  saveDebugConfig() {
    this.http.put('/api/push/debug-config', {
      enabled: this.debugEnabled,
      madarstopToken: this.debugMadarstopToken,
      madarproToken: this.debugMadarproToken
    }).subscribe();
  }

  onToggle(config: any) {
    this.http.put('/api/push/config', {
      appName: config.appName,
      platform: config.platform,
      isActive: config.isActive ? 0 : 1
    }).subscribe(() => {
      config.isActive = config.isActive ? 0 : 1;
    });
  }

  onWeatherEnabledChange() {
    this.saveWeatherConfig();
  }

  onWeatherTimeChange() {
    this.saveWeatherConfig();
  }

  onCitiesChange() {
    this.saveWeatherConfig();
  }

  saveWeatherConfig() {
    this.http.put('/api/push/weather-config', {
      enabled: this.weatherEnabled,
      hour: parseInt(this.weatherHour, 10),
      minute: parseInt(this.weatherMinute, 10),
      cityIds: this.weatherCityIds
    }).subscribe();
  }

  onSendWeather() {
    const cityIds = this.weatherCityIds.length ? this.weatherCityIds : null;
    const confirmText = cityIds
      ? 'Envoyer les notifications météo aux villes sélectionnées ?'
      : 'Envoyer les notifications météo à toutes les villes ?';

    this.pnotify.notice({
      title: 'Confirmation',
      text: confirmText,
      stack: { firstpos1: 70, firstpos2: 10, modal: true, overlay_close: true },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok', addClass: 'btn btn-chico',
              click: notice => {
                this.weatherLoading = true;
                const body: any = {};
                if (cityIds) body.cityIds = cityIds;
                this.http.post('/api/push/weather', body).subscribe(
                  (result: any) => {
                    this.weatherLoading = false;
                    this.pnotify.success({
                      title: 'Succès',
                      text: result.sent + ' notification(s) météo envoyée(s)'
                    });
                  },
                  (error) => {
                    this.weatherLoading = false;
                    this.pnotify.error({
                      title: 'Erreur',
                      text: error.error ? error.error.error : 'Une erreur est survenue !'
                    });
                  }
                );
                notice.close();
              }
            },
            {
              text: 'Annuler', addClass: 'btn btn-default',
              click: (notice) => { notice.close(); notice.fire('pnotify.cancel', { notice }); }
            }
          ]
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/push/push-config/push-config.component.ts